<template>
    <div class="pt-6">
        <input-radio-boolean
            class="flex items-center"
            label="Send notifications about this deal?"
            :name="name"
            :value="value"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {},
        value: {},
        read_only: { default: false },
    },
}
</script>
